export function hasLogisticDepartment({ next, store }) {
  if (typeof store.state.user.state !== "undefined" && store.state.mainRole.team.name === "logistica") {
    return next();
  } else {
    return next("/login");
  }
}
